export const RECEIVE_EDUCATOR = 'EDUCATOR/RECEIVE_EDUCATOR';
export const EDUCATOR_VERIFIED = 'EDUCATOR/EDUCATOR_VERIFIED';
export const EDUCATOR_EMAIL_CONFIRMED = 'EDUCATOR/EDUCATOR_EMAIL_CONFIRMED';
export const RECEIVE_DASHBOARD_STATS = 'EDUCATOR/RECEIVE_DASHBOARD_STATS';
